module.exports = __webpack_public_path__ + "assets/img/17_1047.8e4ce078.jpg";